export const core = {
  // ------------------------------------------------------------ app
  'app.name': 'تباشير',
  'app.tagline': 'إدارة المدرسة',
  'app.loading': 'جارٍ التحميل…',

  // ------------------------------------------------------------ common
  'common.save': 'حفظ',
  'common.saving': 'جارٍ الحفظ…',
  'common.cancel': 'إلغاء',
  'common.close': 'إغلاق',
  'common.confirm': 'تأكيد',
  'common.back': 'رجوع',
  'common.next': 'التالي',
  'common.edit': 'تعديل',
  'common.add': 'إضافة',
  'common.create': 'إنشاء',
  'common.remove': 'حذف',
  'common.retry': 'إعادة المحاولة',
  'common.search': 'بحث',
  'common.all': 'الكل',
  'common.yes': 'نعم',
  'common.no': 'لا',
  'common.none': '—',
  'common.optional': 'اختياري',
  'date.day': 'اليوم',
  'date.month': 'الشهر',
  'date.year': 'السنة',
  'common.required': 'مطلوب',
  'common.print': 'طباعة',
  'common.view': 'عرض',
  'common.details': 'التفاصيل',
  'common.actions': 'إجراءات',
  'common.status': 'الحالة',
  'common.date': 'التاريخ',
  'common.month': 'الشهر',
  'common.amount': 'المبلغ',
  'common.total': 'المجموع',
  'common.note': 'ملاحظة',
  'common.reason': 'السبب',
  'common.name': 'الاسم',
  'common.phone': 'رقم الهاتف',
  'common.code': 'الرمز',
  'common.type': 'النوع',
  'common.from': 'من',
  'common.to': 'إلى',
  'common.filter': 'تصفية',
  'common.clearFilters': 'مسح التصفية',
  'common.loadMore': 'عرض المزيد',
  'common.previous': 'السابق',
  'common.pageOf': 'صفحة {page} من {pages}',
  'common.showingOf': '{from}–{to} من {total}',
  'common.copy': 'نسخ',
  'common.copied': 'تم النسخ',
  'common.done': 'تم',
  'common.active': 'فعّال',
  'common.inactive': 'غير فعّال',
  'common.savedOk': 'تم الحفظ',
  'common.today': 'اليوم',
  'common.selectPlaceholder': 'اختر…',
  'common.months': '{n} شهر',
  'common.readOnly': 'عرض فقط',
  'common.notAllowed': 'لا تملك صلاحية هذا الإجراء',
  'common.searchMin': 'اكتب حرفين على الأقل',
  'common.noResults': 'لا نتائج مطابقة',
  'common.language': 'English',
  'common.languageLabel': 'اللغة',
  'common.openMenu': 'فتح القائمة',
  'common.closeMenu': 'إغلاق القائمة',

  // ------------------------------------------------------------ validation
  'validation.required': 'هذا الحقل مطلوب',
  'validation.money.invalid': 'أدخل مبلغاً صحيحاً',
  'validation.money.decimals': 'عدد الخانات العشرية أكثر من المسموح',
  'validation.money.positive': 'يجب أن يكون المبلغ أكبر من صفر',
  'validation.phone': 'رقم هاتف غير صحيح',
  'validation.password': 'كلمة المرور ٦ أحرف على الأقل',
  'validation.passwordMatch': 'كلمتا المرور غير متطابقتين',
  'validation.code': 'الرمز ٦ أرقام',
  'validation.date': 'تاريخ غير صحيح',
  'validation.futureDate': 'لا يمكن أن يكون التاريخ في المستقبل',
  'validation.maxAmount': 'المبلغ أكبر من المتبقي ({max})',

  // ------------------------------------------------------------ errors (API codes)
  'error.VALIDATION_FAILED': 'بعض البيانات غير صحيحة. راجع الحقول المظللة.',
  'error.NOT_FOUND': 'لم يُعثر على السجل المطلوب.',
  'error.CONFLICT': 'يوجد سجل بالبيانات نفسها.',
  'error.FORBIDDEN': 'لا تملك صلاحية هذا الإجراء.',
  'error.UNAUTHENTICATED': 'انتهت الجلسة. سجّل الدخول من جديد.',
  'error.INVALID_CREDENTIALS': 'رقم الهاتف أو كلمة المرور غير صحيحة.',
  'error.PASSWORD_NOT_SET': 'لم تُعيَّن كلمة مرور لهذا الحساب بعد. اطلب رمز التفعيل.',
  'error.OTP_INVALID': 'الرمز غير صحيح أو منتهي الصلاحية.',
  'error.TOKEN_INVALID': 'انتهت الجلسة. سجّل الدخول من جديد.',
  'error.SCHOOL_REQUIRED': 'اختر المدرسة أولاً.',
  'error.SCHOOL_SUSPENDED': 'هذه المدرسة موقوفة. تواصل مع إدارة المنصّة.',
  'error.SCHOOL_READ_ONLY': 'المدرسة في وضع القراءة فقط؛ لا يمكن الحفظ حالياً.',
  'error.FEATURE_DISABLED': 'هذه الميزة متوقفة في مدرستك.',
  'error.FEATURE_NEEDS': 'فعّل الميزات المطلوبة أولاً.',
  'error.FEATURE_HAS_DEPENDENTS': 'إيقاف هذه الميزة يوقف ميزات تعتمد عليها.',
  'error.FEATURE_NOT_YOURS': 'هذه الميزة تتحكم بها جهة أخرى.',
  'error.PAYROLL_HAS_OPEN_ADVANCES': 'لا يمكن إيقاف الرواتب ما دامت هناك سُلف مفتوحة.',
  'error.IDEMPOTENCY_KEY_REQUIRED': 'تعذّر إرسال الطلب بأمان. أعد المحاولة.',
  'error.IDEMPOTENCY_KEY_REUSED': 'هذا الطلب أُرسل سابقاً لعملية أخرى. أغلق النموذج وافتحه من جديد.',
  'error.SELF_APPROVAL': 'لا يمكنك الموافقة على طلب قدّمته بنفسك.',
  'error.SEPARATION_OF_DUTIES': 'فصل المهام: من وافق لا يصرف، ومن أعدّ لا يعتمد. يجب أن ينفّذ هذا شخص آخر.',
  'error.INVALID_STATE': 'لا يمكن تنفيذ هذا الإجراء في الحالة الحالية.',
  'error.REFERENCE_REQUIRED': 'رقم المرجع مطلوب لغير الدفع النقدي.',
  'error.CASH_ACCOUNT_MISMATCH': 'الحساب المختار لا يقبل طريقة الدفع هذه.',
  'error.CASH_DAY_CLOSED': 'يوم الصندوق مُغلق. التصحيح بقيد عكسي فقط.',
  'error.NOTE_REQUIRED': 'اكتب ملاحظة تشرح الفرق قبل الإغلاق.',
  'error.DEDUCTION_CAP_EXCEEDED': 'القسط الشهري يتجاوز الحد القانوني للاستقطاع.',
  'error.ADVANCE_TOO_LONG': 'السداد بهذا القسط يتجاوز ٦٠ شهراً.',
  'error.ADVANCE_IN_PAYROLL': 'قسط هذه السلفة في مسودة مسيّر رواتب؛ احذف المسودة أولاً.',
  'error.NO_CONTRACT': 'لا يوجد عقد ساري لهذا الموظف.',
  'error.PAYROLL_LOCKED': 'مسيّر هذا الشهر معتمد ومقفل.',
  'error.NO_CURRENT_YEAR': 'حدّد السنة الدراسية الحالية أولاً من الإعدادات.',
  'error.TOO_MANY_REQUESTS': 'محاولات كثيرة. انتظر دقيقة ثم أعد المحاولة.',
  'error.INTERNAL': 'حدث خطأ في الخادم. أعد المحاولة بعد قليل.',
  'error.NETWORK': 'تعذّر الاتصال بالخادم. تحقق من الإنترنت ثم أعد المحاولة؛ إعادة الحفظ آمنة.',
  'error.ERROR': 'حدث خطأ غير متوقع.',
  'error.pageTitle': 'تعذّر تحميل هذه الصفحة',
  'error.notFoundTitle': 'الصفحة غير موجودة',
  'error.notFoundBody': 'ربما نُقلت الصفحة أو أن الرابط غير صحيح.',
  'error.goHome': 'العودة إلى لوحة التحكم',
  'error.featureOffTitle': 'هذه الميزة متوقفة',
  'error.featureOffBody': 'فعّلها من «ميزات المدرسة» أو تواصل مع إدارة المنصّة.',
  'error.forbiddenTitle': 'لا تملك صلاحية هذه الصفحة',

  // ------------------------------------------------------------ roles
  'role.OWNER': 'المالك',
  'role.MANAGER': 'مدير المدرسة',
  'role.ACCOUNTANT': 'المحاسب',
  'role.TEACHER': 'مدرّس',
  'role.STAFF': 'موظف',
  'role.PARENT': 'ولي أمر',
  'role.STUDENT': 'طالب',
  'role.PLATFORM': 'إدارة المنصّة',

  // ------------------------------------------------------------ country
  'country.IQ': 'العراق',
  'country.LY': 'ليبيا',
  'currency.IQD': 'دينار عراقي',
  'currency.LYD': 'دينار ليبي',

  // ------------------------------------------------------------ navigation
  'nav.group.general': 'عام',
  'nav.group.finance': 'المالية',
  'nav.group.staff': 'الموظفون',
  'nav.group.admin': 'الإدارة',
  'nav.group.platform': 'المنصّة',
  'nav.dashboard': 'لوحة التحكم',
  'nav.students': 'الطلاب',
  'nav.receive': 'استلام دفعة',
  'nav.payments': 'المدفوعات',
  'nav.cash': 'إغلاق الصندوق',
  'nav.fees': 'الرسوم والخصومات',
  'nav.staff': 'الموظفون',
  'nav.payroll': 'الرواتب',
  'nav.advances': 'السُّلف',
  'nav.settings': 'الإعدادات',
  'nav.features': 'ميزات المدرسة',
  'nav.platform': 'المدارس',
  'nav.platformCodes': 'رموز التفعيل',
  'nav.skip': 'تخطَّ إلى المحتوى',

  // ------------------------------------------------------------ shell
  'shell.online': 'متصل · الحفظ آمن عند الانقطاع',
  'shell.offline': 'غير متصل',
  'shell.offlineBanner': 'لا يوجد اتصال بالإنترنت. يمكنك متابعة التصفح؛ وعند الحفظ أعد المحاولة بعد عودة الاتصال — لن يُسجَّل أي مبلغ مرتين.',
  'shell.backOnline': 'عاد الاتصال',
  'shell.readOnlyBanner': 'المدرسة في وضع القراءة فقط بسبب الاشتراك. يمكنك الاطلاع على البيانات دون تعديلها.',
  'shell.trialBanner': 'المدرسة في الفترة التجريبية.',
  'shell.year': 'السنة الدراسية {name}',
  'shell.noYear': 'لا توجد سنة دراسية حالية',
  'shell.switchSchool': 'تبديل المدرسة أو الدور',
  'shell.signOut': 'تسجيل الخروج',
  'shell.account': 'الحساب',
  'shell.platformConsole': 'لوحة إدارة المنصّة',

  // ------------------------------------------------------------ auth
  'auth.title': 'تسجيل الدخول',
  'auth.subtitle': 'لوحة إدارة المدرسة للإدارة والمحاسبة',
  'auth.country': 'الدولة',
  'auth.phone': 'رقم الهاتف',
  'auth.phoneHint': 'كما هو مسجّل في المدرسة، مثل {example}',
  'auth.password': 'كلمة المرور',
  'auth.signIn': 'دخول',
  'auth.signingIn': 'جارٍ الدخول…',
  'auth.firstTime': 'أول مرة أو نسيت كلمة المرور؟',
  'auth.setTitle': 'تعيين كلمة المرور',
  'auth.setSubtitle': 'نرسل رمزاً من ٦ أرقام إلى هاتفك المسجّل في المدرسة.',
  'auth.purpose.SET_PASSWORD': 'أول دخول',
  'auth.purpose.RESET_PASSWORD': 'نسيت كلمة المرور',
  'auth.sendCode': 'أرسل الرمز',
  'auth.codeSent': 'إن كان الرقم مسجّلاً فسيصلك رمز خلال دقيقة.',
  'auth.code': 'رمز التحقق',
  'auth.newPassword': 'كلمة المرور الجديدة',
  'auth.confirmPassword': 'تأكيد كلمة المرور',
  'auth.setAndSignIn': 'حفظ والدخول',
  'auth.resend': 'إرسال الرمز من جديد',
  'auth.backToLogin': 'العودة إلى تسجيل الدخول',
  'auth.chooseTitle': 'اختر المدرسة',
  'auth.chooseSubtitle': 'حسابك مرتبط بأكثر من مدرسة أو دور.',
  'auth.mobileOnly': 'هذا الدور يستخدم تطبيق الهاتف',
  'auth.noOfficeRole': 'حسابك لا يملك دوراً إدارياً في أي مدرسة. استخدم تطبيق تباشير على الهاتف.',
  'auth.passwordNotSetHint': 'هذا الحساب لم تُعيَّن له كلمة مرور بعد.',
  'auth.setPasswordNow': 'تعيين كلمة المرور الآن',

  // ------------------------------------------------------------ domain labels
  'method.CASH': 'نقداً',
  'method.CARD': 'بطاقة',
  'method.TRANSFER': 'تحويل بنكي',
  'method.CHEQUE': 'صك',
  'method.WALLET': 'محفظة إلكترونية',
  'paymentStatus.PENDING': 'بانتظار التسوية',
  'paymentStatus.CLEARED': 'مُحصَّل',
  'paymentStatus.BOUNCED': 'مرتجع',
  'paymentStatus.REVERSED': 'معكوس',
  'paymentKind.RECEIPT': 'وصل قبض',
  'paymentKind.REVERSAL': 'قيد عكسي',
  'feeStatus.PAID': 'مسدّد',
  'feeStatus.OVERDUE': 'متأخر',
  'feeStatus.DUE': 'قسط قادم',
  'installmentStatus.PAID': 'مسدّد',
  'installmentStatus.PARTIAL': 'مدفوع جزئياً',
  'installmentStatus.OVERDUE': 'متأخر',
  'installmentStatus.UPCOMING': 'قادم',
  'discountStatus.PENDING': 'بانتظار الموافقة',
  'discountStatus.APPROVED': 'مُعتمد',
  'discountStatus.REJECTED': 'مرفوض',
  'discountStatus.CANCELLED': 'ملغى',
  'advanceStatus.PENDING': 'بانتظار الموافقة',
  'advanceStatus.APPROVED': 'مُوافق عليها · بانتظار الصرف',
  'advanceStatus.REJECTED': 'مرفوضة',
  'advanceStatus.CANCELLED': 'ملغاة',
  'advanceStatus.ACTIVE': 'قيد السداد',
  'advanceStatus.SETTLED': 'مسدَّدة',
  'advanceStatus.WRITTEN_OFF': 'مشطوبة',
  'payrollStatus.DRAFT': 'مسودة',
  'payrollStatus.APPROVED': 'معتمد',
  'payrollStatus.PAID': 'مدفوع',
  'payrollKind.REGULAR': 'المسيّر الشهري',
  'payrollKind.CORRECTION': 'مسيّر تصحيحي',
  'payrollKind.FINAL_SETTLEMENT': 'تسوية نهائية',
  'cashType.CASH_DESK': 'صندوق نقدي',
  'cashType.BANK': 'حساب مصرفي',
  'cashType.WALLET': 'محفظة إلكترونية',
  'source.PAYMENT': 'وصولات الرسوم',
  'source.PAYMENT_REVERSAL': 'قيود عكسية',
  'source.ADVANCE_PAYOUT': 'صرف سُلف',
  'source.ADVANCE_REPAYMENT': 'سداد سُلف نقداً',
  'source.SALARY_PAYMENT': 'رواتب',
  'source.EXPENSE': 'مصروفات',
  'source.ADJUSTMENT': 'تسويات',
  'gender.MALE': 'ذكر',
  'gender.FEMALE': 'أنثى',
  'relation.FATHER': 'الأب',
  'relation.MOTHER': 'الأم',
  'relation.GUARDIAN': 'ولي الأمر',
  'relation.OTHER': 'آخر',
  'studentStatus.ACTIVE': 'مسجّل',
  'studentStatus.WITHDRAWN': 'منسحب',
  'studentStatus.GRADUATED': 'متخرّج',

  // ------------------------------------------------------------ dashboard
  'dashboard.title': 'لوحة التحكم',
  'dashboard.subtitle': 'اليوم · {date}',
  'dashboard.kpi.collectedToday': 'المحصّل اليوم',
  'dashboard.kpi.receipts': '{n}',
  'dashboard.kpi.monthInstallments': 'أقساط هذا الشهر',
  'dashboard.kpi.monthDetail': '{collected} من {due}',
  'dashboard.kpi.noMonthDue': 'لا أقساط مستحقة هذا الشهر',
  'dashboard.kpi.overdue': 'طلاب متأخرون',
  'dashboard.kpi.overdueAmount': 'متأخرات {amount}',
  'dashboard.kpi.noOverdue': 'لا متأخرات',
  'dashboard.kpi.openAdvances': 'سُلف مفتوحة',
  'dashboard.kpi.outstanding': 'المتبقي {amount}',
  'dashboard.collection.title': 'تحصيل رسوم السنة',
  'dashboard.collection.detail': '{collected} من {expected} · {percent}',
  'dashboard.collection.cleared': 'محصّل',
  'dashboard.collection.pending': 'تحويلات وصكوك بانتظار التسوية',
  'dashboard.collection.remaining': 'غير محصّل',
  'dashboard.approvals.title': 'بانتظار موافقتك',
  'dashboard.approvals.titleWriter': 'بانتظار التنفيذ',
  'dashboard.approvals.empty': 'لا شيء بانتظارك الآن',
  'dashboard.approvals.count': '{n} بالانتظار',
  'dashboard.approval.DISCOUNT': 'خصم',
  'dashboard.approval.ADVANCE_DECISION': 'طلب سلفة',
  'dashboard.approval.ADVANCE_PAYOUT': 'سلفة بانتظار الصرف',
  'dashboard.approval.PAYROLL_APPROVAL': 'مسيّر رواتب للاعتماد',
  'dashboard.approval.PAYROLL_PAYMENT': 'رواتب بانتظار الدفع',
  'dashboard.recent.title': 'آخر الوصولات',
  'dashboard.recent.new': 'استلام دفعة جديدة',
  'dashboard.recent.empty': 'لم تُسجَّل وصولات بعد',
  'dashboard.recent.all': 'كل المدفوعات',
  'dashboard.feesOff': 'الرسوم متوقفة في هذه المدرسة، لذلك لا تظهر مؤشرات التحصيل.',
  'common.defaultAccount': 'الحساب الافتراضي',
  'pwa.update': 'يتوفر إصدار جديد من تباشير.',
  'pwa.reload': 'تحديث الآن',
  'error.NO_STAFF_RECORD': 'لا يوجد ملف موظف مرتبط بهذا الحساب.',
  'error.TOO_MANY_ATTEMPTS': 'محاولات دخول خاطئة كثيرة لهذا الرقم. انتظر قليلاً أو عيّن كلمة مرور جديدة برمز التحقق.',
  'error.OWNER_MUST_DECIDE': 'سلفة المدير يقرّرها المالك فقط.',
  'error.ALREADY_PAID': 'هذا الراتب مدفوع مسبقاً.',
  'nav.group.attendance': 'الحضور',
  'nav.attendance': 'الحضور اليومي',
  'nav.attendanceReport': 'التقرير الشهري',
  'nav.notes': 'ملاحظات المعلّمين',
  'nav.group.academics': 'الأكاديمي',
  'nav.timetable': 'الجدول الدراسي',
  'nav.grades': 'الدرجات',
  'error.NOT_YOUR_CLASS': 'هذه الشعبة غير مسندة إليك.',
  'error.SCHOOL_HOLIDAY': 'هذا اليوم عطلة مدرسية؛ لا يُسجَّل فيه حضور.',
  'error.ATTENDANCE_DATE_LOCKED': 'لا يمكن تسجيل الحضور لهذا التاريخ. المدرّس يسجّل اليوم والأيام الستة السابقة فقط، ولا يُسجَّل يوم مستقبلي.',
  'error.SMS_NOT_AVAILABLE': 'لا تتوفر خدمة رسائل SMS لهذه الدولة بعد. أنشئ رمزاً وأعطه للشخص بنفسك.',
  'error.STUDENT_LOGIN_GRADE': 'لا يحصل طلاب هذا الصف على حساب. يبدأ دخول الطلاب من الصف المحدد في إعدادات المدرسة.',
  'error.TEACHER_BUSY': 'لدى المدرّس حصة أخرى في هذا الوقت.',
  'error.NO_GRADING_PLAN': 'لا توجد خطة درجات لهذه المرحلة. أنشئها من الإعدادات ← الدرجات.',
  'error.GRADING_PLAN_IN_USE': 'أُدخلت درجات بهذه الخطة لامتحانات ستُحذف أو لا توجد في الخطة الجديدة، فلا يمكن ذلك.',
  'error.GRADES_LOCKED': 'هذه الدرجات منشورة، ولا يعدّلها إلا المدير.',
  'nav.platformOverview': 'نظرة عامة',
  'nav.platformPeople': 'الأشخاص',
  'shell.subscriptionEnded': 'انتهى اشتراك المدرسة، فأصبحت للقراءة فقط. تواصل مع تباشير لتجديده؛ يعود كل شيء كما كان فور تسجيل الدفعة.',
  'shell.subscriptionEnding': 'ينتهي اشتراك المدرسة خلال {n} ({date}). تواصل مع تباشير للتجديد.',
  'shell.subscriptionEndsToday': 'ينتهي اشتراك المدرسة اليوم. تواصل مع تباشير للتجديد.',
  'shell.subscriptionGrace': 'انتهى اشتراك المدرسة في {date}، وتصبح للقراءة فقط من {readOnly} ما لم يُجدَّد. تواصل مع تباشير.',
} as const;
